var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("booking-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "bookingTreeGrid",
        attrs: {
          view: _vm.view,
          context: _vm.context,
          "is-sales-for-szfs": _vm.isSalesForSzfs
        },
        on: {
          look: _vm.lookHandle,
          edit: _vm.editHandle,
          copy: _vm.copyHandle,
          add: _vm.addHandle,
          lockJob: _vm.lockFormEventBatch,
          submitJob: _vm.submitFormEventBatch
        }
      }),
      _c("booking-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "bookingWorkspace",
        attrs: {
          "parent-context": _vm.context,
          "is-sales-for-szfs": _vm.isSalesForSzfs
        },
        on: {
          edit: _vm.editHandle,
          copy: _vm.copyHandle,
          add: _vm.addHandle,
          lockJob: _vm.lockFormEvent,
          submitJob: _vm.submitFormEvent,
          back: _vm.backToList
        }
      }),
      _c("job-copy-window", {
        attrs: { visible: _vm.copyDialog.visible, lob: "remoteBooking" },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.doCopyJob
        }
      }),
      _c("job-no-rule-selector", {
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: _vm.doCopyJob
        }
      }),
      _vm.railwayLobDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                visible: _vm.railwayLobDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_BusinessType"),
                width: _vm.$selectByLang(
                  "300px",
                  "300px",
                  "300px",
                  "400px",
                  "400px",
                  "400px"
                ),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.railwayLobDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.railwayLobDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    "flex-direction": "column",
                    "padding-bottom": "10px"
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.railwayLobDialog.lob,
                        callback: function($$v) {
                          _vm.$set(_vm.railwayLobDialog, "lob", $$v)
                        },
                        expression: "railwayLobDialog.lob"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
                      ]),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-left": "-20px" },
                          attrs: { no: "RI", label: "RI" }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Confirm", type: "primary" },
                      on: { click: _vm.confirmRailwayLobHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Cancel" },
                      on: {
                        click: function() {
                          _vm.railwayLobDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.checkRow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.checkRow.lob,
              job: _vm.checkRow,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }